import React, { useContext } from 'react';
import {
  Box,
  Text,
  Divider,
  Flex,
  Icon,
  IconButton
} from '@chakra-ui/react';
import { MdArrowBack } from 'react-icons/md';
import SharedExperienceIcon from '../../../components/icons/sharedExperienceIcon';
import SharedExperienceNameForm from './sharedExperienceNameForm';
import { useSmartBackToPreviousPath } from '../../../lib/useSmartBackToPreviousPath';
import InlineFormWrapper from '../../../components/inlineFormWrapper';
import SharedExperiencesInSharedExperienceList from './sharedExperiencesInSharedExperienceList';
import ProductInSharedExperiencesList from './productInSharedExperiencesList';
import PersonaInSharedExperiencesList from './personaInSharedExperiencesList';
import { useNavigate } from 'react-router-dom';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
import { SharedExperiencePageContext } from '../lib/sharedExperiencePageContext';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import SharedExperienceAsideEditMenu from './sharedExperienceAsideEditMenu';
export default function SharedExperienceAside() {
  const { sharedExperience, rights } = useContext(SharedExperiencesContext);
  const { sharedExperienceList, addingSharedExperience } = useContext(SharedExperiencePageContext);
  const goBack = useSmartBackToPreviousPath();
  const navigate = useNavigate();
  return (
    <Flex
      flexShrink={"0"}
      w="275px"
      borderRight="1px"
      borderColor="divider.grey"
      borderRadius="2px"
      backgroundColor="white"
      alignItems={'stretch'}
      flexDirection={'column'}
      position="relative"
      overflow={"auto"}
      pt={1}
    >
      <Flex px={1}>
        <IconButton
          alignSelf={"flex-start"}
          variant="greyTransparent"
          icon={<MdArrowBack />}
          size="lg"
          onClick={goBack}
        />
      </Flex>
      <Flex
        flexDirection={"column"}
        alignItems={'flex-start'}
        gap={2}
        mb={3}
        px={3}
      >
        <Flex
          alignItems={'center'}
        >
          <Icon
            as={SharedExperienceIcon}
            color="text.medium.grey"
            boxSize="12px"
            mr={1}
          />
          <Text
            fontSize={12}
            color="text.medium.grey"
          >
            Shared Experiences
          </Text>
        </Flex>
        <InlineFormWrapper
          canEdit={rights.can_update}
          width={"100%"}
          value={
            <Text
              fontSize={20}
              color="fill.green"
              textAlign={"left"}
            >
              {sharedExperience.name}
            </Text>
          }
        >
          {(close) => (
            <SharedExperienceNameForm
              onSubmitted={close}
              onCancel={close}
            />
          )}
        </InlineFormWrapper>
        <Flex alignSelf="center">
          <SharedExperienceAsideEditMenu />
        </Flex>
      </Flex>
      <Divider ml={3} borderColor="green.200" width="calc(100% - 24px)" />
      <Box w="100%" py={3}>
        <PersonaInSharedExperiencesList
          sharedExperienceId={sharedExperience.id}
        />
      </Box>
      <Divider ml={3} borderColor="green.200" width="calc(100% - 24px)" />
      <Box w="100%" py={3}>
        <ProductInSharedExperiencesList
          sharedExperienceId={sharedExperience.id}
        />
      </Box>
      {((sharedExperienceList && sharedExperienceList.length > 0) || addingSharedExperience) && (
        <>
          <Divider ml={3} borderColor="green.200" width="calc(100% - 24px)" />
          <Box w="100%" py={3}>
            <SharedExperiencesInSharedExperienceList
              sharedExperienceId={sharedExperience.id}
            />
          </Box>
        </>
      )}
    </Flex>
  );
} 